"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function GenerationsInPrint() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imgRef,
    isVisible: isImgVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="145289" id="our-passion-for-cavaliers" className="relative w-full bg-background py-16 md:py-24 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-0 items-center">
          
          {}
          <div ref={imgRef} className={`lg:col-span-8 lg:col-start-5 relative order-1 lg:order-2 h-[450px] sm:h-[550px] lg:h-[700px] rounded-2xl overflow-hidden shadow-xl transition-all duration-1000 ease-out ${isImgVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            <img src="https://brave-rhino.10web.cloud/wp-content/uploads/2026/03/IMG_6741-1-scaled.jpg" alt="A warm, candid moment of a Cobrnik Cavalier breeder interacting with puppies in a sunlit room" className="w-full h-full object-cover" />
            {}
            <div className="absolute inset-0 bg-secondary/10 mix-blend-multiply pointer-events-none"></div>
          </div>

          {}
          <div ref={textRef} className={`lg:col-span-6 lg:col-start-1 relative z-10 order-2 lg:order-1 lg:-mr-24 transition-all duration-1000 delay-300 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="bg-primary/90 backdrop-blur-md p-8 md:p-12 lg:p-16 rounded-2xl shadow-2xl border border-secondary/20">
              <h1 className="font-serif text-4xl md:text-5xl lg:text-6xl font-light text-primary-foreground leading-tight mb-6">
                Our Passion for Cavaliers
              </h1>
              <p className="text-lg text-primary-foreground/90 mb-8 leading-relaxed">As an AKC Breeder of Merit and member of the Cavalier King Charles Spaniel Club, Cobrnik is dedicated to preserving the regal grace and gentle temperament of the Cavalier King Charles Spaniel. Each of our puppies is raised within our home, ensuring a foundation of health, love, and excellence for your future companion.</p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Button asChild size="lg" className="rounded-full px-8 h-12 text-base bg-background text-primary hover:bg-secondary hover:text-primary transition-colors border-none">
                  <Link to="/OurCavaliersPage">
                    Meet Our Cavaliers
                    <ArrowRight className="ml-2 size-5" />
                  </Link>
                </Button>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}